import { render } from "./EnbProduto02.vue?vue&type=template&id=5521b9ea&scoped=true"
import script from "./EnbProduto02.vue?vue&type=script&lang=js"
export * from "./EnbProduto02.vue?vue&type=script&lang=js"

import "./EnbProduto02.vue?vue&type=style&index=0&id=5521b9ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5521b9ea"]])

export default __exports__